import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/logo.png";

export default function Check({ value, setValue, setSideValue }) {
  const [checked, setChecked] = React.useState(false);
  const notify = () => {
    checked
      ? toast.success("Congratuations! You solved the puzzle", {
          position: "top-center",
          autoClose: 6000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        })
      : toast.error("Wrong! Try again", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  };
  const checkTheTrigon = () => {
    value.A1 + value.A2 + value.B2 !== 7
      ? setChecked(false)
      : value.C1 + value.C2 + value.D1 !== 3
      ? setChecked(false)
      : value.B1 + value.C2 + value.C3 !== 6
      ? setChecked(false)
      : value.C3 + value.C4 + value.D2 !== 7
      ? setChecked(false)
      : value.C4 + value.C5 + value.B2 !== 4
      ? setChecked(false)
      : value.C5 + value.C6 + value.D3 !== 2
      ? setChecked(false)
      : value.C6 + value.C7 + value.B3 !== 4
      ? setChecked(false)
      : value.C7 + value.C8 + value.D4 !== 3
      ? setChecked(false)
      : value.E1 + value.E2 + value.D1 !== 5
      ? setChecked(false)
      : value.E2 + value.E3 + value.F1 !== 1
      ? setChecked(false)
      : value.E3 + value.E4 + value.D2 !== 2
      ? setChecked(false)
      : value.E4 + value.E5 + value.F2 !== 4
      ? setChecked(false)
      : value.E5 + value.E6 + value.D3 !== 5
      ? setChecked(false)
      : value.E6 + value.E7 + value.F3 !== 5
      ? setChecked(false)
      : value.E7 + value.E8 + value.D4 !== 6
      ? setChecked(false)
      : value.G1 + value.G2 + value.F1 !== 3
      ? setChecked(false)
      : value.G2 + value.G3 + value.H1 !== 9
      ? setChecked(false)
      : value.G3 + value.G4 + value.F2 !== 8
      ? setChecked(false)
      : value.G4 + value.G5 + value.H2 !== 6
      ? setChecked(false)
      : value.G5 + value.G6 + value.F3 !== 0
      ? setChecked(false)
      : setChecked(true);
    console.log(checked);
  };
  const clearTheTrigon = () => {
    setValue(
      {
        A1: "",
        A2: "",
        B1: "",
        B2: "",
        B3: "",
        C1: "",
        C2: "",
        C3: "",
        C4: "",
        C5: "",
        C6: "",
        C7: "",
        C8: "",
        D1: "",
        D2: "",
        D3: "",
        D4: "",
        E1: "",
        E2: "",
        E3: "",
        E4: "",
        E5: "",
        E6: "",
        E7: "",
        E8: "",
        F1: "",
        F2: "",
        F3: "",
        G1: "",
        G2: "",
        G3: "",
        G4: "",
        G5: "",
        G6: "",
        H1: "",
        H2: "",
      },
      setSideValue({
        "000": false,
        "001": false,
        "002": false,
        "003": false,
        "013": false,
        "023": false,
        "033": false,
        133: false,
        233: false,
        333: false,
        "011": false,
        "012": false,
        "022": false,
        113: false,
        123: false,
        223: false,
        111: false,
        112: false,
        122: false,
        222: false,
      })
    );
  };
  return (
    <div className="w-screen flex justify-center mt-6 lg:mt-0">
      <ToastContainer />
      <div className="lg:w-[80rem] w-10/12  flex justify-between items-center">
        <div className="h-12 md:h-16">
          <img src={logo} alt="logo" className="h-full"/>
        </div>

        <div className="flex gap-x-4">
          <button
            className="p-2 md:p-3 lg:p-4 w-24 bg-emerald-900 text-white rounded-md z-20"
            onClick={() => {
              checkTheTrigon();
              notify();
            }}
          >
            Check
          </button>
          <button
            className=" p-2 md:p-3 lg:p-4  w-24 bg-emerald-900 text-white rounded-md z-20"
            onClick={clearTheTrigon}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
